module.exports = __webpack_public_path__ + "static/media/Brand Image.cb909deb.jpg";